<template>
  <div id="google-drive-synchro-modal" tabindex="-1" aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full">
    <div class="relative w-full   max-w-xl  ">
      <!-- Modal content -->
      <div class=" relative pt-4 pb-2 bg-gray-200 rounded-lg shadow   ">
        <!-- Modal header -->

        <div
          class="px-4 flex items-center justify-between pb-2 mb-2 border-b border-gray-200 rounded-t sm:mb-2 ">

          <h3 class="font-semibold text-gray-900 text-lg   ">
            *211* {{ labels['TITLE_MAIN'][lg] }}
          </h3>

          <button type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click=" onClose()">
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <div class="relative bg-gray-50 rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">
          <div class="w-full  flex flex-col ">







            <div class="mt-2 w-full    flex  h-9">

              En confirmant la synchronisation, l'ensemble des fichiers dont le type a été sélectionné vont être
              télécharger.



            </div>
            <hr class="my-6" />


            <div class="flex items-center mb-4">
              <input id="default-checkbox" v-model="mode" type="checkbox" value=""
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500    ">
              <label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900 ">Forcer le
                téléchargement, même si le fichier est présent.</label>
            </div>




            <div class=" w-full flex flex-row   mt-6 py-2 h-9">


            </div>

          </div>

        </div>

        <div class="flex items-center justify-end px-4  ">
          <button type="button"
            class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
            @click=" onClose()">
            Annuler
          </button>
          <button type="button"
            class="inline-flex items-center text-white   font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
            :class="{'bg-gray-400':disabledValidate, 'bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300':!disabledValidate}"
            @click="onValidate">
            Confirmer
          </button>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
  import labels from "@/assets/lg/google-drive-synchro.json"





  import { mapGetters } from "vuex";

  export default {
    name: 'GoogleDriveSyncrhoModal',
    props: {
      input: Object
    }, components: {

    },
    computed: {
      ...mapGetters({ user: "StateUser" }),
      isLoggedIn: function () {
        return this.$store.getters.isAuthenticated;
      },
    },
    data() {
      return ({
        lg: "FR",
        labels: labels,


        mode: false,
        id: null,
        show_form: true,



        value: ""
      })
    },
    watch: {
      'filteredEntities': async function () {
        if ((this.user.entity_id != null) && (this.user.entity_id != "all"))
          this.entity_id = this.user.entity_id
        else
          if (this.entities.length == 1) this.entity_id = this.entities[0]._id


      },
      'input': async function () {
        this.id = this.input?.id
        this.value = this.input?.batch_number

        this.$nextTick(() => {
          //this.$refs['input-batch-number'].focus();
        });

        if (this.members.length == 0) {
          await this.loadMembers()
        }

        if (this.vets.length == 0) {
          await this.loadVets()
        }

        if (this.entities.length == 0) {
          await this.loadEntities()
        }
        this.controlled_at = this.formatDate(this.input?.source?.controlled_at)
        this.controlled_by_id = this.input?.source?.controlled_by_id
        this.reviewed_by_id = this.input?.source?.reviewed_by_id
        if (this.input?.source?.entity_id != null) {
          this.entity_id = this.input?.source?.entity_id;

        }
        else {
          if ((this.user.entity_id != null) && (this.user.entity_id != "all")) {
            this.entity_id = this.user.entity_id

          }

          else
            if (this.entities.length == 1) {

              this.entity_id = this.entities[0]._id
            }

        }
        this.show_form = false
        this.view = this.input?.view
        this.show_form = true
      }
    },
    async mounted() {
      this.id = this.input?.id
      this.mode = false


      this.$nextTick(() => {
        // this.$refs['input-batch-number'].focus();
      });
    },

    methods: {
      onValidate() {
        this.show_form = false
        this.$emit("confirm", { forced_mode: this.mode })
        this.mode = false
        // this.name = ""
      },
      onClose() {
        this.show_form = false
        this.mode = false
        this.$emit("close")
      }
    },

  }
</script>